import template from './sw-cms-el-config-acris-blog-image-slider.html.twig';
import './sw-cms-el-config-acris-blog-image-slider.scss';

const { Component, Mixin } = Shopware;

Component.register('sw-cms-el-config-acris-blog-image-slider', {
    template,

    mixins: [
        Mixin.getByName('cms-element')
    ],

    computed: {
        addCoverImageOptions() {
            return [
                {
                    value: 'default',
                    label: this.$tc('acris-blog.elements.blogImageSlider.config.label.addCoverImageOptionDefault'),
                },
                {
                    value: 'first',
                    label: this.$tc('acris-blog.elements.blogImageSlider.config.label.addCoverImageOptionFirst'),
                }
            ];
        },

        displayModeValueOptions() {
            return [
                {
                    value: 'standard',
                    label: this.$tc('sw-cms.elements.general.config.label.displayModeStandard'),
                },
                {
                    value: 'contain',
                    label: this.$tc('sw-cms.elements.general.config.label.displayModeContain'),
                },
                {
                    value: 'cover',
                    label: this.$tc('sw-cms.elements.general.config.label.displayModeCover'),
                },
            ];
        },

        verticalAlignValueOptions() {
            return [
                {
                    value: 'flex-start',
                    label: this.$tc('sw-cms.elements.general.config.label.verticalAlignTop'),
                },
                {
                    value: 'center',
                    label: this.$tc('sw-cms.elements.general.config.label.verticalAlignCenter'),
                },
                {
                    value: 'flex-end',
                    label: this.$tc('sw-cms.elements.general.config.label.verticalAlignBottom'),
                },
            ];
        },

        navigationArrowsValueOptions() {
            return [
                {
                    value: 'none',
                    label: this.$tc('sw-cms.elements.imageSlider.config.label.navigationPositionNone'),
                },
                {
                    value: 'inside',
                    label: this.$tc('sw-cms.elements.imageSlider.config.label.navigationPositionInside'),
                },
                {
                    value: 'outside',
                    label: this.$tc('sw-cms.elements.imageSlider.config.label.navigationPositionOutside'),
                },
            ];
        },

        navigationDotsValueOptions() {
            return [
                {
                    value: 'none',
                    label: this.$tc('sw-cms.elements.imageSlider.config.label.navigationPositionNone'),
                },
                {
                    value: 'inside',
                    label: this.$tc('-cms.elements.imageSlider.config.label.navigationPositionInside'),
                },
                {
                    value: 'outside',
                    label: this.$tc('sw-cms.elements.imageSlider.config.label.navigationPositionOutside'),
                },
            ];
        },
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.initElementConfig('acris-blog-image-slider');
        }
    }
});